export default "__VITE_ASSET__BIb04MO2__"